// An itinerary item's `day` can fall after the tour's last day: templates from
// longer tours carry those days, and a tour's dates can be shortened later.

/** True when an item's day isn't one of this tour's days. */
export function isOutsideTour(item, nDays) {
  const idx = (item.day || 1) - 1;
  return !(idx >= 0 && idx < nDays);
}

/** The items that fit on a tour of nDays. */
export function itemsInsideTour(items, nDays) {
  return (items || []).filter((item) => !isOutsideTour(item, nDays));
}
